import { Descendant } from "slate";
import { jsx } from "slate-hyperscript";
import { CustomText } from "./custom-types";

export const htmlToJsonSlate = (value: string): Descendant[] => {
  const parsed = new DOMParser().parseFromString(
    value ? value : "<p></p>",
    "text/html"
  );

  return deserialize(parsed.body);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deserialize = (el: HTMLElement | ChildNode): any => {
  if (el.nodeType === 3) {
    return el.textContent;
  } else if (el.nodeType !== 1) {
    return null;
  }

  let children: CustomText[] = Array.from(el.childNodes).map(deserialize);

  if (children.length === 0) {
    children = [
      {
        text: "",
      },
    ];
  }

  const createCustomText = (el: HTMLElement) => {
    return {
      text: el.textContent,
      fontSize: el.style.fontSize,
      bold: el.style.fontWeight ? true : false,
      italic: el.style.fontStyle ? true : false,
      underline: el.style.textDecoration ? true : false,
      color: el.style.color ? el.style.color : false,
      background: el.style.backgroundColor ? el.style.backgroundColor : false,
    };
  };

  const textAlign = el instanceof HTMLElement ? el.style.textAlign : "";
  const href = el instanceof HTMLElement ? el.getAttribute("href") : "";

  switch (el.nodeName) {
    case "BODY":
      return jsx("fragment", {}, children);
    case "BR":
      return "\n";
    case "BLOCKQUOTE":
      return jsx("element", { type: "quote" }, children);
    case "P":
      return jsx(
        "element",
        textAlign
          ? { type: "text-align", align: textAlign }
          : { type: "paragraph" },
        children
      );
    case "SPAN":
      return jsx(
        "text",
        el instanceof HTMLElement ? createCustomText(el) : undefined,
        children
      );
    case "A":
      return jsx("element", { type: "link", url: href }, children);
    default:
      return el.textContent;
  }
};
